<template>
  <div
    class="container d-flex flex-column p-0"
    style="max-width: 100%; height: 100%"
  >
    <div class="row" style="flex: 1">
      <div
        class="d-flex flex-column"
        :class="isCollapse ? 'col-12 collapse' : 'pe-0 col-7'"
      >
        <div
          class="header-tab d-flex justify-content-between gap-1 pe-0"
          ref="workflow"
        >
          <div class="d-flex gap-1">
            <div
              class="py-2"
              v-for="(item, index) in workflows"
              :key="item.id"
              style="cursor: pointer"
            >
              <span
                :class="{ active: selectedWorkflow?.id === item?.id }"
                :style="{ color: item.color }"
                @click="
                  app.globalProcessId != 'all'
                    ? openDialogChangeWorkflow(item)
                    : null
                "
              >
                {{ index + 1 }}. {{ item.title }}
              </span>
            </div>
          </div>
        </div>
        <div style="flex: 1">
          <div
            class="content h-100 container px-0 d-flex justify-content-center m-0"
            style="max-width: 100% !important"
          >
            <div class="row w-100">
              <div
                class="info col-4"
                style="border-right: 1px #ececec solid"
                ref="info"
              >
                <div class="px-3 py-3 d-flex flex-column gap-2 h-100">
                  <div class="d-flex align-items-center gap-2">
                    <span class="title text-uppercase fw-semibold"
                      >Thông tin chung</span
                    >
                    <div
                      class="icon"
                      v-if="
                        permissionContactWrite && app.globalProcessId != 'all'
                      "
                      @click="openUpdateContact"
                    >
                      <IconFont
                        style="margin-top: 1px; margin-left: 3px"
                        :size="'12px'"
                        :color="'#FFFFFF'"
                        :name="'icon-edit'"
                      />
                    </div>
                  </div>
                  <div
                    class="additional-info h-100"
                    v-if="getFieldsName.length"
                    style="overflow-y: auto; height: 350px"
                  >
                    <div
                      v-for="field in getFieldsName.filter((f) => f.value)"
                      :key="field.title"
                    >
                      <span
                        class="text fw-semibold me-2"
                        style="word-break: break-all"
                        >{{ field.title }}:</span
                      >
                      <LinkifiedText :text="field.value" :newline-to-br="false" />
                    </div>
                    <div v-if="createdBy">
                      <span class="text fw-semibold me-2">Người tạo:</span>
                      <span>{{ createdBy == 'system' ? 'Hệ thống' : createdBy }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="history mt-2 d-flex flex-column col-8 px-0">
                <div class="flex-line-between tab-container">
                  <div class="d-flex align-item-center ms-3">
                    <div
                      v-for="item in tabList"
                      :key="item.value"
                      class="spm-tab-item me-2"
                      :class="item.value == curTab && 'active'"
                      @click="handleTabClick(item.value)"
                      :ref="'tab-' + item.value"
                    >
                      {{ item.title }}
                      <!-- <div
                        v-if="item.value == 0 && permissionContactLog"
                        class="icon ms-2"
                        @click="openDialogHistory"
                      >
                        <IconFont
                          style="margin-top: 2px; margin-left: 1.8px"
                          :size="'14px'"
                          :color="'#FFFFFF'"
                          :name="'icon-add'"
                        />
                      </div> -->
                    </div>
                  </div>
                </div>
                <div
                  v-if="curTab == 0"
                  class="mt-2"
                  style="border-top: 1px #ececec solid"
                >
                  <!-- <div v-if="!permissionContactLog">Không có quyền thao tác lịch sử.</div> -->
                  <AddHistory
                    @close-dialog="closeDialogHistory"
                    @created="onCreatedActivity"
                    :selectedContact="selectedContact"
                    :processId="processId"
                    :steps="steps"
                    @update="getAllContactNote()"
                  />

                  <div>
                    <div
                      class="ps-3 pe-2 pt-2 note-tab"
                      v-if="activityData.length === 0"
                    >
                      Không có ghi chú nào.
                    </div>
                    <div
                      class="note-tab"
                      v-else
                      style="overflow-y: auto; background-color: #f6f6f6"
                    >
                      <div class="d-flex align-items-center mt-1">
                        <div class="ms-2 me-2">Chọn loại ghi chú:</div>
                        <el-select
                          v-model="type"
                          placeholder="Loại ghi chú"
                          size="small"
                          style="width: 190px"
                        >
                          <el-option
                            v-for="(item, index) in this.noteType"
                            :key="index"
                            :label="item.title"
                            :value="item.value"
                          />
                        </el-select>
                      </div>
                      <div class="pe-2 pt-2">
                        <el-timeline
                          style="padding-left: 10px; margin-top: 8px"
                        >
                          <el-timeline-item
                            v-for="item in activityData"
                            :key="item.id"
                            style="padding-bottom: 0px"
                          >
                            <div
                              class="custom-box d-flex flex-column mb-0 px-1"
                            >
                              <div
                                class="pt-2 ps-1 d-flex justify-content-between"
                              >
                                <div class="d-flex justify-content-start">
                                  <div
                                    class="fw-semibold me-2 spm-tab px-2 py-1 text custom-tab"
                                  >
                                    {{ formatDateTimeShort(item.createAt) }} •
                                    {{ item.swUsername }}
                                  </div>
                                  <div
                                    v-if="
                                      item.type !== 'change_workflow' &&
                                      item.fileIds
                                    "
                                  >
                                    <el-popover
                                      placement="bottom"
                                      trigger="click"
                                    >
                                      <div
                                        v-for="(
                                          file, index
                                        ) in item.fileIds.split(',')"
                                        :key="index"
                                        @click="openFile(file)"
                                      >
                                        <div class="format-select">
                                          <div
                                            class="material-icons"
                                            style="font-size: 16px"
                                          >
                                            attach_file
                                          </div>
                                          {{ getFileName(file) }}
                                        </div>
                                      </div>
                                      <template #reference>
                                        <div class="file-preview">
                                          <div
                                            class="material-icons"
                                            style="font-size: 16px"
                                          >
                                            attach_file
                                          </div>
                                          <div>File đính kèm</div>
                                          <div class="file-count">
                                            ({{
                                              item.fileIds.split(",").length
                                            }})
                                          </div>
                                        </div>
                                      </template>
                                    </el-popover>
                                  </div>
                                </div>
                                <el-button
                                  v-if="item.type !== 'change_workflow'"
                                  style="padding: 4px"
                                  size="mini"
                                  @click="onDeleteHistory(item.id)"
                                >
                                  <IconFont
                                    color="primary"
                                    name="icon-delete"
                                  />
                                </el-button>
                              </div>

                              <div class="ps-2 mt-1">
                                <span class="text fw-semibold me-2">
                                  Trạng thái:
                                  <span class="ms-1" style="color: #327ae7">
                                    {{
                                      getStepTitle(item.workflowId) !==
                                      "Không xác định"
                                        ? getStepTitle(item.workflowId)
                                        : item.title
                                    }}
                                  </span>
                                </span>
                              </div>
                              <div class="ps-2 mt-1">
                              <span class="me-2">
                                <span class="fw-semibold text">Ghi chú:</span>
                                <span
                                  class="ms-1"
                                  style="white-space: normal; overflow-wrap: break-word"
                                  v-html="renderNoteWithMention(item)"
                                ></span>
                              </span>
                            </div>
                            </div>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="curTab == 1"
                  class="mt-2"
                  style="border-top: 1px #ececec solid"
                >
                  <CreateAppointment
                    :contactId="contactId"
                    :selectedContact="selectedContact"
                    @success="getAppointment"
                  />
                  <div style="overflow-y: auto" class="tab-appointment">
                    <div class="pe-2 pt-2">
                      <el-timeline style="padding-left: 10px; margin-top: 8px">
                        <el-timeline-item
                          v-for="item in appointmentTimeline"
                          :key="item._kind + '_' + item.id"
                          style="padding-bottom: 0px"
                        >
                          <!-- Task entry -->
                          <div
                            v-if="item._kind === 'task'"
                            class="custom-box d-flex flex-column mb-0 px-1"
                          >
                            <div class="pt-2 ps-1 d-flex justify-content-between">
                              <div class="d-flex justify-content-start align-items-center">
                                <div class="fw-semibold me-2 spm-tab px-2 py-1 text custom-tab">
                                  📋 {{ item.code || 'CV-' + item.id }}
                                  <span v-if="item.assigneeUsername">• {{ item.assigneeUsername }}</span>
                                </div>
                                <div
                                  class="ms-1 px-2 py-1"
                                  :style="{
                                    color: taskStatusColor(item.statusKey),
                                    background: taskStatusColor(item.statusKey) + '22',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                  }"
                                >
                                  {{ taskStatusLabel(item.statusKey) }}
                                </div>
                                <span
                                  v-if="taskPriorityInfo(item.priority)"
                                  class="ms-2"
                                  :style="{ color: taskPriorityInfo(item.priority).color, fontWeight: 700 }"
                                  :title="taskPriorityInfo(item.priority).label"
                                >{{ taskPriorityInfo(item.priority).icon }}</span>
                              </div>
                              <div>
                                <el-tooltip content="Mở chi tiết" placement="top">
                                  <el-button
                                    style="padding: 4px"
                                    size="mini"
                                    @click="openTaskDetail(item)"
                                  >
                                    <IconFont color="primary" name="icon-edit" />
                                  </el-button>
                                </el-tooltip>
                              </div>
                            </div>
                            <div class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Tiêu đề:
                                <span class="ms-1" style="color: #327ae7;">{{ item.title }}</span>
                              </span>
                            </div>
                            <div v-if="item.dueAt" class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Hạn chót:
                                <span class="ms-1">{{ taskDueDisplay(item) }}</span>
                              </span>
                            </div>
                            <div v-if="item.reporterUsername" class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Người giao:
                                <span class="ms-1">{{ item.reporterUsername }}</span>
                              </span>
                            </div>
                          </div>

                          <!-- Appointment entry (original layout) -->
                          <div
                            v-else
                            class="custom-box d-flex flex-column mb-0 px-1"
                          >
                            <div
                              class="pt-2 ps-1 d-flex justify-content-between"
                            >
                              <div class="d-flex justify-content-start">
                                <div
                                  class="fw-semibold me-2 spm-tab px-2 py-1 text custom-tab"
                                >
                                  {{ formatDateTimeShort(item.createAt) }} •
                                  {{ item.createdBy }}
                                </div>
                                <div class="d-flex noti-custom">
                                  <img
                                    class="icon-img-large"
                                    src="@/assets/icons/notifications.svg"
                                  />
                                  <div class="d-flex align-items-center">
                                    {{ item.timeNotify }}
                                    {{ getTimeNotiUnit(item.timeNotifyUnit) }}
                                  </div>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div
                                    class="ms-1"
                                    :style="getStatusStyle(item.status)"
                                  >
                                    {{ getStatus(item.status) }}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <el-tooltip
                                  content="Chỉnh sửa"
                                  placement="top"
                                >
                                  <el-button
                                    style="padding: 4px"
                                    size="mini"
                                    @click="openUpdateDialog(item)"
                                    :disabled="item.status ==='DONE' || item.status ==='CANCEL'"
                                    v-if="item.createdBy === app.user.swUsername || app.user.type =='ADMIN'"
                                  >
                                    <IconFont
                                      color="primary"
                                      name="icon-edit"
                                    />
                                  </el-button>
                                </el-tooltip>
                                <el-tooltip
                                  content="Đánh dấu hoàn thành"
                                  placement="top"
                                >
                                  <el-button
                                    style="padding: 4px; margin-left: 2px"
                                    size="mini"
                                    @click="
                                      onUpdateStatusAppointment(item, 'DONE')
                                    "
                                    v-if="item.createdBy === app.user.swUsername || app.user.type == 'ADMIN'"
                                    :disabled="item.status ==='DONE' || item.status ==='CANCEL'"
                                  >
                                    <IconFont
                                      color="primary"
                                      name="icon-multiple-option"
                                    />
                                  </el-button>
                                </el-tooltip>

                                <el-tooltip
                                  content="Hủy"
                                  placement="top"
                                >
                                  <el-button
                                    style="padding: 4px; margin-left: 2px"
                                    size="mini"
                                    @click="
                                      onUpdateStatusAppointment(item, 'CANCEL')
                                    "
                                    v-if="item.createdBy === app.user.swUsername || app.user.type == 'ADMIN'"
                                    :disabled="item.status ==='DONE' || item.status ==='CANCEL'"
                                  >
                                    <IconFont
                                      color="primary"
                                      name="icon-delete"
                                    />
                                  </el-button>
                                </el-tooltip>
                              </div>
                            </div>
                            <div class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Tên lịch hẹn:
                                <span class="ms-1" style="color: #327ae7; white-space: normal; overflow-wrap: break-word; word-break: normal;">
                                  {{ item.name }}
                                </span>
                              </span>
                            </div>
                            <div class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Thời gian:
                                <span class="ms-1">
                                  {{
                                    formatTimeRange(
                                      item.timeStart,
                                      item.timeEnd
                                    )
                                  }}
                                </span>
                              </span>
                            </div>
                            <div class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Người tham gia:
                                <el-tooltip
                                v-if="item.participants"
                                :content="getParticipants(item.participants)"
                                placement="top"
                              >
                                <span class="ms-1" style=" white-space: normal; overflow-wrap: break-word; word-break: normal;">
                                  {{ getParticipants(item.participants) }}
                                </span>
                              </el-tooltip>
                              </span>
                            </div>
                            <div class="ps-2 mt-1">
                              <span class="text fw-semibold me-2">
                                Ghi chú:
                                <span class="ms-1" style=" white-space: normal; overflow-wrap: break-word; word-break: normal;">
                                  <LinkifiedText v-if="item.note" :text="item.note" />
                                  <template v-else>Không có ghi chú</template>
                                </span>
                              </span>
                            </div>
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                  <DialogUpdateAppointment
                    v-if="dialogUpdateAppointment"
                    :appointment="selectedAppointment"
                    @close="dialogUpdateAppointment = false"
                    @success="getAppointment"
                  />
                </div>
                <div
                  v-if="curTab == 2"
                  class="mt-2 ps-3 pe-2"
                  style="border-top: 1px #ececec solid"
                >
                  <div
                    class="mt-2 tab-log-system"
                    v-if="logSysData.length === 0"
                  >
                    Không có lịch sử thao tác nào.
                  </div>
                  <div
                    v-else
                    class="tab-log-system"
                    style="height: 490px; overflow-y: auto"
                  >
                    <div class="pe-1 pt-2">
                      <div v-for="(item, index) in logSysData" :key="index">
                        <div class="item-log" v-if="item.length > 0 && item.some(col => !checkExistColumn(col))">
                          <div
                            class="title-item p-1"
                            style="
                              font-weight: 700;
                              color: #696b72;
                              margin-left: 5px;
                            "
                          >
                            {{ formatDateTimeShort(item[0].createAt) }}:
                            <span
                              v-if="item[0].type === 'CREATE'"
                              style="color: #696b72"
                              >nhân viên {{ item[0].swEmployee }} đã thêm dữ
                              liệu trường</span
                            >
                            <span v-else style="color: #696b72"
                              >nhân viên {{ item[0].swEmployee }} cập nhật thông
                              tin</span
                            >
                          </div>
                          <div v-for="i in item" :key="i.id">
                            <span
                              v-if="!checkExistColumn(i)"
                              class="d-inline-block"
                              style="
                                background-color: #ffffff;
                                padding: 4px 8px;
                                border-radius: 4px;
                                margin: 2px 8px;
                              "
                            >
                              <span>{{ getFieldName(i) }}:</span>
                              <span
                                v-if="i.type === 'UPDATE' || i.type === 'UPDATE_PROCESS'"
                                style="
                                  color: gray;
                                  text-decoration: line-through;
                                  margin-left: 4px;
                                "
                                >{{ getOldValue(i) }}</span
                              ><span class="mx-1">-></span
                              ><span style="font-weight: 700">{{
                                getNewValue(i)
                              }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="curTab == 3"
                  class="mt-2 tab-log-call"
                  style="overflow-y: auto; border-top: 1px #ececec solid"
                >
                  <el-table
                    height="100%"
                    :data="tableData"
                    stripe
                    class="table-call"
                  >
                    <el-table-column prop="phone" width="150">
                      <template slot="header">
                        <div>
                          <span class="me-2">Số điện thoại</span>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="Đồng bộ"
                            placement="top"
                            v-if="app.stringee"
                          >
                            <i
                              class="el-icon-refresh"
                              style="cursor: pointer"
                              @click="getSyncLog"
                            ></i>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ formatPhone(scope.row.phone) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="startAt"
                      label="Bắt đầu"
                      width="100"
                      align="center"
                    >
                      <template #default="scope">
                        {{ scope.row.startAt ? formatDate(scope.row.startAt) : formatDateITY(scope.row.startStamp) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="endAt"
                      label="Kết thúc"
                      width="100"
                      align="center"
                    >
                      <template #default="scope">
                        {{ scope.row.endAt ? formatDate(scope.row.endAt) : formatDateITY(scope.row.endStamp) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="startAnswerAt"
                      label="Trả lời"
                      width="100"
                      align="center"
                    >
                      <template #default="scope">
                        {{ scope.row.startAnswerAt ? formatDate(scope.row.startAnswerAt) : formatDateITY(scope.row.answerStamp) }}
                      </template></el-table-column
                    >
                    <!-- <el-table-column prop="note" label="Ghi chú" width="200">
                <template #default="scope">
                  {{ scope.row.note }}
                </template>
              </el-table-column> -->
                    <el-table-column
                      prop="answerSec"
                      label="Thời lượng"
                      width="100"
                      align="center"
                    >
                      <template #default="scope">
                        <div>
                          <div>{{ scope.row.answerSec ? formatDuration(scope.row.answerSec) : formatAnswerSecITY(scope.row.billSec) }}</div>
                          <div
                            v-if="scope.row.price"
                            class="price"
                            style="
                              background-color: #ececec;
                              border-radius: 4px;
                              text-align: center;
                            "
                          >
                            {{ scope.row.price }} đ
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="billSec" label="Tổng thời lượng đổ chuông" width="220">
                <template #default="scope">
                  {{ formatDuration(scope.row.billSec) }}
                </template></el-table-column
              > -->
                    <!-- <el-table-column prop="price" label="Cước phí" width="150"></el-table-column> -->
                    <el-table-column prop="username" label="Nhân viên">
                      <template #default="scope">
                        <div style="color: #2970dd; font-weight: 600">
                          {{ scope.row.username }}
                        </div>
                        <div v-if="scope.row.deviceCode" class="price">
                          {{ scope.row.deviceCode }}
                        </div>
                        <div v-if="scope.row.extension" class="price">
                          {{ scope.row.extension }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="recordingUrl" label="Ghi âm" width="270">
                      <template #default="scope">
                        <!-- URL public: phát trực tiếp bằng thẻ audio -->
                        <audio
                          v-if="
                            scope.row.recordingUrl &&
                            scope.row.centerCode != 'STRINGEE'
                          "
                          controls
                          preload="metadata"
                          :src="scope.row.recordingUrl"
                          style="width: 250px; height: 36px; vertical-align: middle"
                        ></audio>
                        <!-- STRINGEE: file lấy qua endpoint blob có auth -->
                        <template
                          v-else-if="
                            scope.row.recordingUrl &&
                            scope.row.centerCode == 'STRINGEE'
                          "
                        >
                          <audio
                            v-if="scope.row.audioSrc"
                            controls
                            autoplay
                            :src="scope.row.audioSrc"
                            style="width: 250px; height: 36px; vertical-align: middle"
                          ></audio>
                          <div
                            v-else
                            @click="loadStringeeRecording(scope.row)"
                            style="color: #327ae7; cursor: pointer"
                          >
                            {{
                              scope.row.direction === "outbound"
                                ? "Nghe ghi âm (Gọi đi)"
                                : scope.row.direction === "inbound"
                                ? "Nghe ghi âm (Gọi đến)"
                                : "Nghe ghi âm"
                            }}
                          </div>
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column type="expand" class-name="expand-column">
                      <template #default="{ row }">
                        <div class="note">
                          <span
                            style="
                              font-weight: 600;
                              white-space: nowrap;
                              color: #7a7f83;
                            "
                            >Ghi chú:
                          </span>
                          <el-tooltip
                            v-if="row.note"
                            class="item"
                            effect="dark"
                            :content="row.note"
                            placement="top"
                          >
                            <span
                              class="ellipsis-text-note"
                              style="color: #a3a7ab"
                            ><LinkifiedText :text="row.note" /></span>
                          </el-tooltip>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div
                  v-if="curTab == 4"
                  class="mt-2 tab-log-call"
                  style="overflow-y: auto; border-top: 1px #ececec solid"
                >
                  <el-table
                    height="100%"
                    :data="chatLogData"
                    stripe
                    class="table-call"
                  >
                    <el-table-column prop="phone" width="150">
                      <template slot="header">
                        <div>
                          <span class="me-2">Số điện thoại</span>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="Đồng bộ"
                            placement="top"
                            v-if="app.stringee"
                          >
                            <i
                              class="el-icon-refresh"
                              style="cursor: pointer"
                              @click="getSyncLog"
                            ></i>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ formatPhone(scope.row.phone) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="displayName" label="Hội thoại">
                      <template #default="scope">
                        <div>
                          {{ scope.row.displayName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="Nền tảng">
                      <template #default="scope">
                        <div>
                          {{ scope.row.type }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="Kênh">
                      <template #default="scope">
                        <div>
                          {{ scope.row.channel ? scope.row.channel : "" }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="username" label="Nhân viên">
                      <template #default="scope">
                        <div style="color: #2970dd; font-weight: 600">
                          {{ scope.row.employeeId.split('_')[1] }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createAt" label="Thời gian">
                      <template #default="scope">
                        <div>
                          {{ formatDateTimeShort(scope.row.createAt) }} - {{ scope.row.endAt ? formatDateTimeShort(scope.row.endAt) : '...' }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="text-align: center; padding: 10px">
                    <el-button v-if="curTab == 4 && hasMore"
                      type="primary"
                      size="mini"
                      :loading="isLoading"
                      @click="fetchLogChat"
                    >
                      Xem thêm
                    </el-button>
                    <el-button @click="showDialogExportLog = true">Xuất dữ liệu</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <el-dialog
      title="Thêm ghi chú mới"
      :visible.sync="dialogHistory"
      width="420px"
      :close-on-click-modal="false"
      append-to-body
      class="history"
    >

    </el-dialog> -->
        <el-dialog
          :title="currentItem?.title || 'Dialog'"
          v-if="dialogChangeWorkflow"
          @close="dialogChangeWorkflow = false"
          :visible="true"
          style="min-width: 420px"
          :close-on-click-modal="false"
          append-to-body
        >
          <DialogChangeWorkflow
            @close-dialog="closeDialog()"
            @updatedContact="onUpdatedContact"
            @updated="onUpdated"
            @expand-dialog="handleDialogWidthChange"
            @updatedWorkflow="updatedWorkflow"
            :contact="selectedContact"
            :steps="steps"
            :newWorkflow="newWorkflow"
            :processId="processId"
            @success="(value) => $emit('successChangeWorkflow', value)"
          />
        </el-dialog>

        <el-dialog
          title="Thêm ghi chú cho bước này"
          v-if="dialogMandatoryNote"
          :visible="true"
          width="420px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="cancelMandatoryNote"
          append-to-body
          class="history"
        >
          <DialogAddHistory
            :selectedContact="selectedContact"
            :steps="steps"
            :processId="processId"
            :mandatory="true"
            :workflowIdOverride="newWorkflow && newWorkflow.id"
            @created="onCreatedMandatoryNote"
            @update="getAllContactNote()"
          />
        </el-dialog>

        <!--Dialog Update Contact-->
        <el-dialog
          title="Chỉnh sửa khách hàng"
          v-if="dialogUpdateContact"
          :visible="true"
          :width="dialogWidth"
          @close="dialogUpdateContact = false"
          style="min-width: 420px"
          append-to-body
        >
          <DialogUpdateContact
            :item="selectedContact"
            @success="closeDialogUpdateContact"
            @close="dialogUpdateContact = false"
            @expand-dialog="handleDialogWidthChange"
          />
        </el-dialog>
        <!-- dialog Infinite Loading -->
        <el-dialog
          title="Thêm lịch hẹn mới"
          v-if="dialogCreateAppointment"
          :width="dialogWidth1"
          :visible="true"
          @close="dialogCreateAppointment = false"
          style="min-width: 520px"
          append-to-body
        >
          <DialogCreateAppointment />
        </el-dialog>
      </div>
      <div
        class="collapse"
        :class="isCollapse ? 'w-0' : 'col-5 ps-0 d-flex flex-column'"
        style="border-left: 1px solid #ececec; overflow: hidden"
      >
        <div
          class="header-tab d-flex justify-content-between align-items-center gap-1"
          ref="workflow"
        >
          <div class="d-flex gap-1">
            <el-tooltip
              class="item"
              effect="dark"
              content="Hội thoại Salework Chat"
              placement="top-start"
            >
              <el-button
                type="primary"
                plain
                :class="isActiveChat ? 'active' : ''"
                class="p-0 d-flex justify-content-center align-items-center btn-conversation"
                @click="clickChat()"
                round
              >
                <img
                  class="img-logo"
                  src="https://chat.salework.net/images/logo.png"
                  alt="logo-chat"
                />
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Hội thoại Zalo"
              placement="top-start"
            >
              <el-button
                type="primary"
                plain
                :class="isActiveZalo ? 'active' : ''"
                class="p-0 d-flex justify-content-center align-items-center btn-conversation"
                @click="clickZalo()"
                round
              >
                <img src="@/assets/icons/zalo.svg" alt="logo-zalo" />
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Lịch sử hoạt động"
              placement="top-start"
            >
              <el-button
                type="primary"
                plain
                :class="isActiveTimeline ? 'active' : ''"
                class="p-0 d-flex justify-content-center align-items-center btn-conversation"
                @click="clickTimeline()"
                round
              >
                <img src="@/assets/icons/list-view.svg" style="width: 18px; height: 18px;" alt="timeline" />
              </el-button>
            </el-tooltip>
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            content="Đóng hội thoại"
            placement="top-start"
          >
            <el-button
              @click="collapseChat()"
              style="border: none; background: transparent"
            >
              <IconFont name="el-icon-close" />
            </el-button>
          </el-tooltip>
        </div>
        <div
          v-if="contact.id"
          class="flex-1"
          style="border-bottom: 1px solid #ececec"
        >
          <ChatConversationList v-if="isActiveChat" :contact="contact" />
          <ZaloConversationList v-if="isActiveZalo" :contact="contact" />
          <TimelineContact v-if="isActiveTimeline" :contact="contact" :workflows="workflows" :processList="app.processList || processList" :columnList="columnList" :app="app" />
        </div>
      </div>
    </div>

    <!-- <span
      slot="footer"
      class="dialog-footer d-flex justify-content-end py-2 px-2"
    >
      <el-button
        size="medium"
        type="primary"
        style="color: #ffffff"
        @click="close"
        >Hủy</el-button
      >
    </span> -->
    <ExportLogChat v-if="showDialogExportLog" @close="showDialogExportLog = false"/>
  </div>
</template>

<script>
import IconFont from "../common/IconFont.vue";
import DialogChangeWorkflow from "./DialogChangeWorkflow.vue";
import AddHistory from "./AddHistory.vue";
import DialogAddHistory from "./DialogAddHistory.vue";
import { HTTP } from "@/lib/http-common";
import { linkifyText } from "@/lib/linkify";
import moment from "moment";
import { startIntro } from "../../lib/introHelper";
import DialogUpdateContact from "./DialogUpdateContact.vue";
import CreateAppointment from "./CreateAppointment.vue";
import { MessageBox } from "element-ui";
import ZaloConversationList from "./ZaloConversationList.vue";
import ChatConversationList from "./ChatConversationList.vue";
import DialogCreateAppointment from "./DialogCreateAppointment.vue";
import DialogUpdateAppointment from "./DialogUpdateAppointment.vue";
import ExportLogChat from "./ExportLogChat.vue";
import TimelineContact from "./TimelineContact.vue";
import taskApi from "@/lib/apis/task";
import { STATUS_LIST, PRIORITY_LIST, formatDue } from "@/components/Task/taskMockData";

export default {
  props: ["contactId", "steps", "processId", "processList"],
  components: {
    DialogUpdateAppointment,
    DialogCreateAppointment,
    CreateAppointment,
    IconFont,
    DialogChangeWorkflow,
    DialogUpdateContact,
    AddHistory,
    DialogAddHistory,
    ZaloConversationList,
    ChatConversationList,
    ExportLogChat,
    TimelineContact,
  },
  data() {
    return {
      tableData: [],
      curTab: 0,
      rawAppointmentData: [],
      // Tasks linked to this contact — rendered alongside appointments in
      // the same timeline (curTab == 1).
      rawTaskData: [],
      tabList: [
        { title: "Ghi chú", value: 0 },
        { title: "Lịch hẹn", value: 1 },
        { title: "Hệ thống", value: 2 },
        { title: "Cuộc gọi", value: 3 },
        { title: "Chat", value: 4},
      ],
      type: [],
      noteType: [],
      dialogHistory: false,
      dialogChangeWorkflow: false,
      dialogMandatoryNote: false,
      currentItem: null,
      allFieldNamesSet: new Set(),
      newWorkflow: null,
      rawActivityData: [],
      // activityData: [],
      selectedContact: null,
      // selectedWorkflow: null,
      isUpdated: false,
      logSysData: [],
      filterSelectedContact: null,
      dialogWidth: "420px",
      dialogWidth1: "600px",
      dialogUpdateContact: false,
      filesData: [],
      isActiveChat: false,
      isActiveZalo: false,
      isActiveTimeline: true,
      isCollapse: false,
      contact: {},
      dialogCreateAppointment: false,
      dialogUpdateAppointment: false,
      selectedAppointment: {},
      statusColorMap: {
        NOT_START: "#327AE7",
        INPROCESS: "#FDAF36",
        DONE: "#218656",
        OVERTIME: "#CF4547",
        CANCEL: "#696B72",
      },
      chatLogData: [],
      page: 0,
      hasMore: true,
      isLoading: false,
      showDialogExportLog: false,
    };
  },

  methods: {
    renderNoteWithMention(item) {
      // Notes can contain URLs and @-mentions. Linkify every non-mention slice
      // so a `https://...` inside the note renders as a clickable link.
      if (!item.note) return 'Không có ghi chú'
      if (!item.mention) return linkifyText(item.note)

      let mentions = []
      try {
        mentions = JSON.parse(item.mention)
      } catch (e) {
        return linkifyText(item.note)
      }

      if (!mentions.length) {
        return linkifyText(item.note)
      }

      let result = ''
      let lastIndex = 0

      mentions
        .sort((a, b) => a.start - b.start)
        .forEach(m => {
          result += linkifyText(item.note.slice(lastIndex, m.start))
          result += `
            <span class="mention-highlight">
              @${this.escapeHtml(m.name)}
            </span>
          `
          lastIndex = m.start + m.length
        })

      result += linkifyText(item.note.slice(lastIndex))
      return result
    },

    escapeHtml(text) {
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br>')
    },
    getStatus(status) {
      switch (status) {
        case "NOT_START":
          return "Chưa bắt đầu";
        case "INPROCESS":
          return "Đang diễn ra";
        case "DONE":
          return "Hoàn thành";
        case "OVERTIME":
          return "Quá hạn";
        case "CANCEL":
          return "Đã hủy";
      }
    },
    getTimeNotiUnit(unit) {
      switch (unit) {
        case "MINUTE":
          return "phút";
        case "HOUR":
          return "giờ";
        case "DAY":
          return "ngày";
        case "MONTH":
          return "tháng";
      }
    },
    getStatusStyle(status) {
      const color = this.statusColorMap[status] || "#999";
      return {
        color: color,
        backgroundColor: this.hexToRgba(color, 0.2),
        padding: "2px 8px",
        borderRadius: "32px",
      };
    },
    hexToRgba(hex, opacity) {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },
    async onUpdateStatusAppointment(item, newStatus) {
      let message =
        newStatus === "DONE"
          ? "Bạn đã HOÀN THÀNH cuộc hẹn này?"
          : "Bạn có chắc chắn muốn HỦY cuộc hẹn này?";

      try {
        await this.$confirm(message, "Xác nhận", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        });

        const res = await HTTP.post("/api/appointment/update-status", null, {
          params: { appointmentId: item.id, status: newStatus },
        });

        if (res.status === "success") {
          this.$message.success("Cập nhật thành công.");
          this.updateAppointmentStatuses();
          this.getAppointment();
        } else {
          this.$message.error(res.error.message);
        }
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    },

    openUpdateDialog(item) {
      this.selectedAppointment = { ...item };
      this.dialogUpdateAppointment = true;
    },
    async getAppointment() {
      try {
        const res = await HTTP.get("/api/appointment/get-by-contactId", {
          params: { contactId: this.contact.id },
        });
        this.rawAppointmentData = res.data.sort((a, b) => b.id - a.id);
        this.updateAppointmentStatuses();
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    },
    // Tasks linked to this contact (shown inline with appointments).
    // Backend returns paginated `{ data: { content: [...] } }`; unwrap.
    async getTasks() {
      if (!this.contact || !this.contact.id) return;
      try {
        const res = await taskApi.list({
          contactId: this.contact.id,
          page: 0,
          size: 200,
        });
        if (!res || res.status !== "success") return;
        const list = Array.isArray(res.data)
          ? res.data
          : (res.data && Array.isArray(res.data.content) ? res.data.content : []);
        this.rawTaskData = list;
      } catch (e) {
        console.error("Error fetching tasks for contact:", e);
      }
    },
    taskStatusLabel(key) {
      const s = STATUS_LIST.find((x) => x.value === key);
      return s ? s.label : key || "";
    },
    taskStatusColor(key) {
      const s = STATUS_LIST.find((x) => x.value === key);
      return s ? s.color : "#9ca3af";
    },
    taskPriorityInfo(p) {
      return PRIORITY_LIST.find((x) => x.value === p) || null;
    },
    taskDueDisplay(t) {
      const v = t.dueAt || t.due || null;
      return v ? formatDue(v) : "";
    },
    // The task detail dialog lives on the Task page. Route there with the
    // task id in the query so it auto-opens, then the openTaskDetail bus
    // event also catches the case where the user is already on /task.
    openTaskDetail(item) {
      this.$bus.$emit("openTaskDetail", item.id);
      if (this.$route.path !== "/task") {
        this.$router.push({ path: "/task", query: { openTask: item.id } });
      }
    },
    updateAppointmentStatuses() {
      const now = new Date();
      const currentMinute = Math.floor(now.getTime() / (60 * 1000));

      this.rawAppointmentData.forEach((appt, index) => {
        const startMinute = Math.floor(appt.timeStart / (60 * 1000));
        const endMinute = Math.floor(appt.timeEnd / (60 * 1000));

        if (
          appt.status === "NOT_START" &&
          currentMinute >= startMinute &&
          currentMinute < endMinute
        ) {
          this.$set(this.rawAppointmentData, index, {
            ...this.rawAppointmentData[index],
            status: "INPROCESS",
          });
        }

        if (
          !["DONE", "CANCEL", "OVERTIME"].includes(appt.status) &&
          currentMinute >= endMinute
        ) {
          this.$set(this.rawAppointmentData, index, {
            ...this.rawAppointmentData[index],
            status: "OVERTIME",
          });
        }
      });
    },
    collapseChat() {
      this.isCollapse = true;
      this.isActiveChat = false;
      this.isActiveZalo = false;
      this.isActiveTimeline = false;
      this.saveToLocalStorage();
      this.$emit('collapseChat');
    },
    clickChat() {
      this.isActiveChat = true;
      this.isActiveZalo = false;
      this.isActiveTimeline = false;
      this.isCollapse = false;
      this.saveToLocalStorage();
    },
    clickZalo() {
      this.isActiveChat = false;
      this.isActiveZalo = true;
      this.isActiveTimeline = false;
      this.isCollapse = false;
      this.saveToLocalStorage();
    },
    clickTimeline() {
      this.isActiveChat = false;
      this.isActiveZalo = false;
      this.isActiveTimeline = true;
      this.isCollapse = false;
      this.saveToLocalStorage();
    },
    saveToLocalStorage() {
      const stored = JSON.parse(localStorage.getItem("chatState")) || {};
      if (!stored[this.app.user.companyCode]) {
        stored[this.app.user.companyCode] = {};
      }
      stored[this.app.user.companyCode][this.app.user.swUsername] = {
        isCollapse: this.isCollapse,
        isActiveChat: this.isActiveChat,
        isActiveZalo: this.isActiveZalo,
        isActiveTimeline: this.isActiveTimeline,
      };

      localStorage.setItem("chatState", JSON.stringify(stored));
    },
    getStepTitle(workflowId) {
      const step = this.steps.find((s) => s.id === workflowId);
      return step ? step.title : "Không xác định";
    },
    onDeleteHistory(row) {
      MessageBox.confirm(
        `Bạn có chắc chắn muốn ghi chú đang chọn?`,
        "Xóa ghi chú",
        {
          confirmButtonText: "Xóa",
          cancelButtonText: "Hủy",
          type: "warning",
        }
      )
        .then(() => {
          this.deleteHistory(row);
        })
        .catch(() => {});
    },
    async deleteHistory(row) {
      const res = await HTTP.post(`/api/activity/delete?id=${row}`);
      if (res.status === "success") {
        this.$message.success("Đã xóa ghi chú thành công.");
        this.$bus.$emit("deleteNote", this.contact.id);
        this.getActivity();
      }
    },
    async getSyncLog() {
      await HTTP.get("/api/call/get-sync-log?phone=" + this.contact.phone);
      await this.getContactLogAll();
    },
    openUpdateContact() {
      this.dialogUpdateContact = true;
    },
    async closeDialogUpdateContact() {
      this.dialogUpdateContact = false;
      this.getLogSystem();
      const res = await HTTP.get(
        "/api/contact/get-by-id?contactId=" + this.contact.id
      );
      if (res.error) {
        this.$message.error(res.error.message);
      }
      this.selectedContact = res.data;
      // this.isUpdated = true;
      this.$emit("updatedContact", {isUpdated: true, isChangeWorkflow: false, contact: this.selectedContact});
    },
    intro() {
      this.$nextTick(() => {
        const steps = [
          {
            element: this.$refs.info,
            intro:
              "Điền thông tin cho các trường dữ liệu đã thiết lập tại bước thiết lập trường",
          },
          {
            element: this.$refs["tab-0"][0],
            intro:
              "Lưu trữ toàn bộ các dữ liệu tương tác với khách hàng do nhân viên ghi lại",
          },
          {
            element: this.$refs["tab-1"][0],
            intro:
              "Thể hiện thông tin thay đổi hệ thống do người dùng thực hiện.",
          },
          {
            element: this.$refs["tab-2"][0],
            intro: "Các thông tin do telesaler ghi lại.",
          },
          {
            element: this.$refs.workflow,
            intro:
              "Dùng để xem trạng thái và chuyển đổi trạng thái của liên hệ",
          },
        ];
        this.introInstance = startIntro(steps);
      });
    },
    onUpdated() {
      this.$emit("onUpdated");
    },
    async getAllContactNote() {
      const res = await HTTP.get(
        "/api/activity/get-note?contactId=" + this.contact.id
      );
      this.filesData = res.data;
    },
    openFile(fileId) {
      const file = this.filesData.find((f) => f.id.trim() === fileId);
      if (!file) {
        console.error("Không tìm thấy file:", fileId);
        return;
      }
      const name = (file.fileName || "").toLowerCase();
      const videoExts = [".mp4", ".mov", ".m4v", ".webm", ".ogg", ".ogv"];
      if (videoExts.some((ext) => name.endsWith(ext))) {
        // Video: mở tab mới với thẻ <video> để phát trực tiếp thay vì tải về
        // (navigate thẳng tới .mov/quicktime bị trình duyệt ép download).
        this.openVideoInNewTab(file.url, file.fileName);
      } else {
        window.open(file.url, "_blank");
      }
    },
    openVideoInNewTab(url, fileName) {
      const win = window.open("", "_blank");
      if (!win) {
        // Popup bị chặn → fallback navigate trực tiếp.
        window.open(url, "_blank");
        return;
      }
      const doc = win.document;
      doc.title = fileName || "Video";
      doc.body.style.cssText =
        "margin:0;height:100vh;background:#000;display:flex;align-items:center;justify-content:center";
      const video = doc.createElement("video");
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.setAttribute("playsinline", "");
      video.style.cssText = "max-width:100%;max-height:100%";
      doc.body.appendChild(video);
    },
    getFileName(fileId) {
      const file = this.filesData.find((f) => f.id.trim() === fileId);
      return file ? file.fileName : "Không tìm thấy file";
    },

    handleTabClick(tabValue) {
      this.curTab = tabValue;
      if (tabValue === 3) {
        this.getContactLogAll();
      }
      if (tabValue === 2) {
        this.getLogSystem();
      }
      if (tabValue == 4) {
        this.fetchLogChat();
      }
    },
    formatDuration(duration) {
      if (!duration) return "00:00:00";
      const hours = Math.floor(duration / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((duration % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (duration % 60).toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },

    formatAnswerSecITY(billSec) {
      if (!billSec || isNaN(billSec)) return "00:00:00";

      const duration = Number(billSec);

      const hours = Math.floor(duration / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((duration % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor(duration % 60)
        .toString()
        .padStart(2, "0");

      return `${hours}:${minutes}:${seconds}`;
    },

    async getContactLogAll() {
      const [res1, res2] = await Promise.all([
        HTTP.get("/api/call/get-log?phone=" + this.contact.phone),
        HTTP.get("/api/callcenter/get-log?phone=" + this.contact.phone),
      ]);

      this.tableData = [
        ...(res1.data || []),
        ...(res2.data || []),
      ].sort((a, b) => b.createAt - a.createAt);
    },
    closeDialogChangeWorkflow() {
      this.dialogChangeWorkflow = false;
      this.currentItem = null;
      this.$emit("close-retail");
    },
    openDialogChangeWorkflow(item) {
      if (!this.permissionContactWrite) {
        this.alert(
          "error",
          "Không có quyền chuyển bước! Vui lòng cài đặt quyền cho người dùng"
        );
        return;
      }
      this.currentItem = item;
      this.newWorkflow = JSON.parse(JSON.stringify(item));
      if (Array.isArray(item.columnList) && item.columnList.includes("note")) {
        this.dialogMandatoryNote = true;
      } else {
        this.dialogChangeWorkflow = true;
      }
    },

    handleDialogWidthChange(shouldExpand) {
      this.dialogWidth = shouldExpand ? "840px" : "420px";
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`;
    },
    formatDateITY(timestamp) {
      if (!timestamp) return "";
      const [datePart, timePart] = timestamp.split("T");
      const [year, month, day] = datePart.split("-");
      const [hours, minutes, seconds] = timePart.split(":");

      return `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`;
    },
    openDialogHistory() {
      this.dialogHistory = true;
    },
    closeDialogHistory() {
      this.dialogHistory = false;
    },
    onCreatedActivity() {
      this.isUpdated = true;
      this.dialogHistory = false;
      this.getActivity();
      this.$emit("createdNote");
    },
    onCreatedMandatoryNote() {
      this.isUpdated = true;
      this.getActivity();
      const pendingWorkflow = this.newWorkflow;
      const pendingItem = this.currentItem;
      this.dialogMandatoryNote = false;
      setTimeout(() => {
        if (pendingWorkflow) {
          this.newWorkflow = pendingWorkflow;
          this.currentItem = pendingItem;
          this.dialogChangeWorkflow = true;
        }
        this.$emit("createdNote");
      }, 350);
    },
    cancelMandatoryNote() {
      this.dialogMandatoryNote = false;
      this.newWorkflow = null;
      this.currentItem = null;
    },
    closeDialog() {
      this.dialogChangeWorkflow = false;
    },
    async getActivity() {
      try {
        const res = await HTTP.get("/api/activity/get-all", {
          params: { contactId: this.contact.id },
        });
        const titleMap = {
          create: "Tạo mới ghi chú",
          create_contact: "Tạo mới liên hệ",
          update_contact: "Chỉnh sửa liên hệ",
          change_workflow: "Chuyển bước",
        };
        const uniqueTypes = [...new Set(res.data.map((p) => p.type))];
        this.noteType = uniqueTypes.map((type) => ({
          title: titleMap[type],
          value: type,
        }));
        this.rawActivityData = res.data;
      } catch (error) {
        console.error("Error fetching activity:", error);
      }
    },
    onUpdateProcess() {
      this.$emit("process");
    },
    async onUpdatedContact(newWorkflow, oldWorkflow) {
      this.isUpdated = true;
      this.dialogChangeWorkflow = false;
      const res = await HTTP.get(
        "/api/contact/get-by-id?contactId=" + this.contact.id
      );
      if (res.error) {
        this.$message.error(res.error.message);
      }
      this.contact = JSON.parse(JSON.stringify(res.data));
      this.selectedContact = res.data;
      // this.$bus.$emit("onUpdate");
      this.$emit("updatedContact", {isUpdated: false, isChangeWorkflow: true, contact: this.selectedContact, targetWorkflow: newWorkflow, sourceWorkflow: oldWorkflow});
      this.getActivity();
      this.getLogSystem();
    },

    updatedWorkflow(id) {
      this.selectedWorkflow = this.workflows.find((item) => item.id === id);
    },

    dateTimeFormat(ts, format = "DD/MM/YYYY") {
      return moment(Number(ts)).format(format);
    },
    getStorageByContact(storageId) {
      const storage = this.app.storageAll.find((st) => st.id === storageId);
      return storage ? storage.name : null;
    },
    async getLogSystem() {
      // if (this.app.globalProcessId != "all") {
      const res = await HTTP.get("/api/log-system", {
        params: { contactId: this.contact.id },
      });
      this.logSysData = [...res.data.body.data].reverse();
      // }
    },
    formatDateTimeShort(time) {
      var date = new Date(time);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      // var seconds = ("0" + date.getSeconds()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);

      return (
        day +
        "/" +
        month +
        "/" +
        date.getFullYear() +
        " " +
        hours +
        ":" +
        minutes
      );
    },
    getFieldName(log) {
      if (log.columnCode === "workflow") {
        return "Bước";
      } else if (log.columnCode === "storage") {
        return "Kho dữ liệu";
      } else if (log.columnCode === "status") {
        return "Trạng thái";
      } else if (log.columnCode === "process") {
        return "Quy trình";
      } else {
        const column = this.columnList.find((c) => c.name === log.columnCode);
        
        if(column){
          return column.title;
        }
        else{
          return "";
        }
      }
    },
    checkExistColumn(log) {
      if (log.columnCode === "workflow") {
        return false;
      } else if (log.columnCode === "storage") {
        return false;
      } else if (log.columnCode === "status") {
        return false;
      } else if (log.columnCode === "process") {
        return false;
      } else {    
      const column = this.columnList.find((c) => c.name === log.columnCode);
      if(column){
        return false;
      }
      else{
        return true;
      }}
    },
    getOldValue(log) {
      const parseValue = (value) => {
        if (
          typeof value === "string" &&
          value.startsWith("[") &&
          value.endsWith("]")
        ) {
          try {
            return JSON.parse(value).join(", ");
          } catch (error) {
            return value;
          }
        } else if (value === null || value === undefined) {
          return "null";
        }
        return value;
      };
      const parseValueEm = (value) => {
        if (!value) return null;
        return value
          .replace(/^\[|\]$/g, "")
          .split(", ")
          .map((val) => {
            const trimmed = val.trim();
            const parts = trimmed.split("/");
            return parts.length > 1 ? parts[1] : parts[0];
          })
          .join(", ");
      };
      switch (log.columnCode) {
        case "workflow": {
          let workflows = JSON.parse(log.valueOld);
          if (typeof workflows === "string" || typeof workflows === "number") {
            if (!this.workflowList) {
              return "";
            }
            const workflowOld = this.workflowList.find(
              wf => wf.id === workflows
            );
            return workflowOld ? workflowOld.title : "";
          }
          // if (this.app.globalProcessId != "all") {
          //   const workflowIdOld = workflows.find(
          //     (wf) => wf.processId === this.app.globalProcessId
          //   )?.workflowId;
          //   if (!workflowIdOld) break;
          //   const workflowOld = this.workflowList.find(
          //     (wf) => wf.id === workflowIdOld
          //   );
          //   return workflowOld ? workflowOld.title : "";
          // } else {
          if (workflows.length == 0) {
            return "";
          }
          let process = this.app.processList.find(
            (pro) => pro.id === workflows[0].processId
          );
          let workflowOld = process.workflowList.find(
            (wf) => wf.id === workflows[0].workflowId
          );
          if (workflowOld && process) {
            return `${workflowOld.title} (${process.name})`;
          } else {
            return "";
          }
          // }
        }
        case "storage": {
          const storage = this.app.storageAll.find(
            (st) => st.id == log.valueOld
          );
          return storage ? storage.name : "";
        }
        case "status": {
          const statusMesOld =
            log.valueOld === "ACTIVE" ? "Đã xác nhận" : "Chờ xác nhận";
          return statusMesOld;
        }
        case "employees": {
          let emOld = parseValueEm(log.valueOld);
          return emOld?.length > 0 ? emOld : "";
        }
        case "process": {
          try {
            const processStatusParse = JSON.parse(log.valueOld);
            let process = this.app.processList.find(
              (pro) => pro.id == processStatusParse[0].processId
            );
            return `${process?.name} (${processStatusParse[0].status == 'OPEN' ? 'Mở' : 'Đóng'})`;
          } catch (e) {
            return "";
          }
        }
        default: {
          const oldValue = parseValue(log.valueOld);
          const column = this.columnList.find((c) => c.name === log.columnCode);
          if(column){
                      if (column.columnType === "Date") {
            return oldValue === "null" || oldValue?.length == 0
              ? ""
              : this.dateTimeFormat(oldValue, "DD/MM/YYYY");
          }
          return oldValue === "null" ? "" : oldValue;
          }
          return "";
        }
      }
    },
    getNewValue(log) {
      const parseValue = (value) => {
        if (
          typeof value === "string" &&
          value.startsWith("[") &&
          value.endsWith("]")
        ) {
          try {
            return JSON.parse(value).join(", ");
          } catch (error) {
            return value;
          }
        } else if (value === null || value === undefined) {
          return "null";
        }
        return value;
      };
      const parseValueEm = (value) => {
        if (!value) return null;
        return value
          .replace(/^\[|\]$/g, "")
          .split(", ")
          .map((val) => {
            const trimmed = val.trim();
            const parts = trimmed.split("/");
            return parts.length > 1 ? parts[1] : parts[0];
          })
          .join(", ");
      };
      switch (log.columnCode) {
        case "workflow": {
          let workflows = JSON.parse(log.valueNew);
          if (typeof workflows === "string" || typeof workflows === "number") {
            if (!this.workflowList) {
              return "";
            }
            const workflowOld = this.workflowList.find(
              wf => wf.id === workflows
            );
            return workflowOld ? workflowOld.title : "";
          }
          // if (this.app.globalProcessId != "all") {
          //   const workflowIdNew = workflows.find(
          //     (wf) => wf.processId === this.app.globalProcessId
          //   )?.workflowId;
          //   if (!workflowIdNew) break;
          //   const workflowNew = this.workflowList.find(
          //     (wf) => wf.id === workflowIdNew
          //   );
          //   return workflowNew ? workflowNew.title : "(bỏ trống)";
          // } else {
          if (workflows.length == 0) {
            return "";
          }
          let process = this.app.processList.find(
            (pro) => pro.id === workflows[0].processId
          );
          let workflowOld = process.workflowList.find(
            (wf) => wf.id === workflows[0].workflowId
          );
          if (workflowOld && process) {
            return `${workflowOld.title} (${process.name})`;
          } else {
            return "(bỏ trống)";
          }
          // }
        }
        case "storage": {
          const storage = this.app.storageAll.find(
            (st) => st.id == log.valueNew
          );
          return storage ? storage.name : "(bỏ trống)";
        }
        case "status": {
          const statusMesNew =
            log.valueNew === "ACTIVE" ? "Đã xác nhận" : "Chờ xác nhận";
          return statusMesNew;
        }
        case "employees": {
          let emNew = parseValueEm(log.valueNew);
          return emNew?.length > 0 ? emNew : "(bỏ trống)";
        }
        case "process": {
          try {
            const processStatusParse = JSON.parse(log.valueNew);
            let process = this.app.processList.find(
              (pro) => pro.id == processStatusParse[0].processId
            );
            return `${process?.name} (${processStatusParse[0].status === 'OPEN' ? 'Mở' : 'Đóng'})`;
          } catch (e) {
            let process = this.app.processList.find(
              (pro) => pro.id == log.valueNew
            );
            return process?.name;
          }
          
        }
        default: {
          const newValue = parseValue(log.valueNew);
          const column = this.columnList.find((c) => c.name === log.columnCode);
          if(column){
                      if (column.columnType === "Date") {
            return newValue === "null" || newValue?.length == 0
              ? "(bỏ trống)"
              : this.dateTimeFormat(newValue, "DD/MM/YYYY");
          }
          return newValue === "null" || newValue == ""
            ? "(bỏ trống)"
            : newValue;
          }
          return "(bỏ trống)";
        }
      }
    },
    async loadStringeeRecording(row) {
      try {
        const res = await HTTP.get(
          `/api/call/download-recording?callId=${row.callId}`,
          {
            responseType: "blob",
          }
        );
        const blob =
          res instanceof Blob ? res : new Blob([res], { type: "audio/wav" });
        const url = window.URL.createObjectURL(blob);
        this.$set(row, "audioSrc", url);
      } catch (error) {
        this.$message.error("Lỗi khi tải file.");
      }
    },
    async getContactById() {
      const res = await HTTP.get(
        "/api/contact/get-by-id?contactId=" + this.contactId
      );
      if (res.error) {
        this.$message.error(res.error.message);
      }
      if (res.status == "success") {
        this.contact = res.data;
      }
    },
    formatPhone(phone) {
      if (!phone) return phone;

      // id nền tảng: conversation_id (a_b_c_d) hoặc t_... — giữ nguyên, không format như SĐT
      if (/^(\d+_\d+_\d+_\d+|t_\d+)$/.test(phone)) return phone;

      phone = phone.replace(/[^a-zA-Z0-9+]/g, '');

      if (phone.startsWith('0')) {
        return '+84' + phone.substring(1);
      } else if (phone.startsWith('84') && !phone.startsWith('+84')) {
        return '+' + phone;
      }

      return phone;
    },
    formatTimeRange(timeStart, timeEnd) {
      if (!timeStart) return "";

      const startDate = new Date(Number(timeStart));
      if (isNaN(startDate.getTime())) return "";

      const padZero = (n) => n.toString().padStart(2, "0");

      const day = padZero(startDate.getDate());
      const month = padZero(startDate.getMonth() + 1);
      const year = startDate.getFullYear();

      const startHour = padZero(startDate.getHours());
      const startMinute = padZero(startDate.getMinutes());

      let result = `${day}/${month}/${year}, ${startHour}:${startMinute}`;

      if (timeEnd) {
        const endDate = new Date(Number(timeEnd));
        if (!isNaN(endDate.getTime())) {
          const endHour = padZero(endDate.getHours());
          const endMinute = padZero(endDate.getMinutes());
          result += ` - ${endHour}:${endMinute}`;
        }
      }

      return result;
    },
    getParticipants(participants) {
      try {
        let ems = JSON.parse(participants);
        return ems.join(", ");
      } catch (e) {
        return "";
      }
    },
    async fetchLogChat() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;

      const res = await HTTP.get(`/api/log-chat/get-log-chat?page=${this.page}&phone=${this.contact?.phone || ""}`);

      const data = res.data?.content || [];

      if (data.length === 0 || data.length < 10) {
        this.hasMore = false;
      }

      this.chatLogData.push(...data);
      this.page++;
      this.isLoading = false;
    },
    // Reset khi mở tab
    resetLogChat() {
      this.chatLogData = [];
      this.page = 0;
      this.hasMore = true;
      this.fetchLogChat();
    },
    exportDataLogChat() {

    },
  },
  computed: {
    createdBy(){
      console.log(123, this.contact);

      return this.contact.createdBy;
    },
    // Merged timeline: appointments + tasks sorted newest first. Each item
    // gets a `_kind` discriminator the template branches on.
    appointmentTimeline() {
      const appts = (this.rawAppointmentData || []).map((a) => ({
        ...a,
        _kind: "appointment",
        _sortKey: a.timeStart || a.createAt || a.id || 0,
      }));
      const tasks = (this.rawTaskData || []).map((t) => ({
        ...t,
        _kind: "task",
        _sortKey: t.dueAt || t.createAt || t.id || 0,
      }));
      return [...appts, ...tasks].sort((a, b) => b._sortKey - a._sortKey);
    },
    selectedWorkflow() {
      const curProcessAndWorkflow = this.contact?.processAndWorkflow?.find(
        (i) => i.processId == this.processId
      );
      if (!curProcessAndWorkflow) return null;

      return this.workflows.find(
        (item) => item.id === curProcessAndWorkflow.workflowId
      );
    },
    activityData() {
      let data = this.rawActivityData;
      if (this.type.length > 0) {
        data = data.filter((item) => item.type == this.type);
      }
      return data.sort((a, b) => b.createAt - a.createAt);
    },
    selectedWorkflowId() {
      return this.contact?.processAndWorkflow?.find(
        (p) => p.processId === this.processId
      )?.workflowId;
    },
    workflows() {
      const workflows = this.steps.filter(
        (item) => item.processId === this.processId
      );
      return workflows;
    },
    getFieldsName() {
      if (this.selectedWorkflow && this.selectedContact) {
        const fields = [];
        this.selectedWorkflow.columnList.forEach((field) => {
          switch (field) {
            case "displayName": {
              fields.push({
                title: "Họ và tên",
                name: "displayName",
                value: this.selectedContact.displayName,
              });
              break;
            }
            case "phone": {
              fields.push({
                title: "Số điện thoại",
                name: "phone",
                value: this.selectedContact.phone,
              });
              break;
            }
            case "email": {
              fields.push({
                title: "Email",
                name: "email",
                value: this.selectedContact.email,
              });
              break;
            }
            case "storage": {
              fields.push({
                title: "Kho dữ liệu",
                name: "storage",
                value: this.getStorageByContact(this.selectedContact.storageId),
              });
              break;
            }
            case "employees": {
              fields.push({
                title: "Nhân viên",
                name: "employees",
                value:
                  this.selectedContact?.swEmployees.length > 0
                    ? this.selectedContact?.swEmployees
                        .map((employee) => employee.username)
                        .join(", ")
                    : "",
              });
            }
          }
        });
        if (this.selectedWorkflow && this.selectedWorkflow.columnList) {
          this.selectedWorkflow.columnList.forEach((field) => {
            const lceField = this.selectedContact.LCE?.length
              ? this.selectedContact.LCE.find((lce) => lce.name === field)
              : null;
            if (lceField) {
              switch (lceField.columnType) {
                case "Date": {
                  fields.push({
                    title: lceField.title, 
                    name: lceField.name,
                    value: lceField.value
                      ? this.dateTimeFormat(lceField.value, "DD/MM/YYYY")
                      : "",
                  });
                  break;
                }
                case "Number":{
                  fields.push({
                    title: lceField.title,
                    name: lceField.name,
                    value: Number(lceField.value).toLocaleString('en-US'), 
                  });
                  break;
                }
                case "MultiSelect": {
                  let parsedValue = "";
                  try {
                    if (lceField.value && lceField.value.trim() !== "") {
                      parsedValue = JSON.parse(lceField.value);
                    }
                  } catch (e) {
                    console.error("JSON parse error:", lceField.value);
                    parsedValue = "";
                  }

                  fields.push({
                    title: lceField.title,
                    name: lceField.name,
                    value: Array.isArray(parsedValue)
                      ? parsedValue.join(", ")
                      : parsedValue || "",
                  });
                  break;
                }
                case "Array":
                case "ArrayNumber": {
                  let parsedValue = "";
                  try {
                    if (
                      typeof lceField.value === "string" &&
                      lceField.value.trim() !== ""
                    ) {
                      parsedValue = JSON.parse(lceField.value);
                    }
                  } catch (e) {
                    console.error("JSON parse error:", lceField.value);
                    parsedValue = "";
                  }

                  fields.push({
                    title: lceField.title,
                    name: lceField.name,
                    value: Array.isArray(parsedValue)
                      ? parsedValue.join(", ")
                      : parsedValue || "",
                  });
                  break;
                }
                default: {
                  fields.push({
                    title: lceField.title,
                    name: lceField.name,
                    value: lceField.value,
                  });
                }
              }
            }
          });
        }
        return fields.filter((column) => {
          const hasPermission = this.checkPermissionFieldRead(column.name);
          return hasPermission;
        });
      }
      return [];
    },
  },
  created() {
    // Stable handler ref so $on/$off can match. Arrow fn / inline handler
    // wouldn't unsubscribe correctly.
    this._onTaskNoti = () => {
      if (this.contact && this.contact.id) this.getTasks();
    };
  },
  async mounted() {
    // this.updateWorkflow();
    await this.getContactById();
    this.getAllContactNote();
    this.getActivity();
    this.getAppointment();
    this.getTasks();
    this.intro();
    // Refresh task list when a task-related socket event arrives so newly
    // created/updated tasks show up alongside appointments.
    this.$bus.$on("taskNotification", this._onTaskNoti);
    this.selectedContact = JSON.parse(JSON.stringify(this.contact));

    const stored = JSON.parse(localStorage.getItem("chatState"));
    if (
      stored &&
      stored[this.app.user.companyCode] &&
      stored[this.app.user.companyCode][this.app.user.swUsername]
    ) {
      const state = stored[this.app.user.companyCode][this.app.user.swUsername];
      this.isCollapse = !!state.isCollapse;
      if (state.isActiveChat) {
        this.isActiveChat = true;
        this.isActiveZalo = false;
        this.isActiveTimeline = false;
      } else if (state.isActiveZalo) {
        this.isActiveChat = false;
        this.isActiveZalo = true;
        this.isActiveTimeline = false;
      } else {
        this.isActiveChat = false;
        this.isActiveZalo = false;
        this.isActiveTimeline = true;
      }
    }
    this.$bus.$on('clickChat', () => this.clickChat());
    this.$bus.$on('clickZalo', () => this.clickZalo());
  },
  beforeDestroy() {
    this.$bus.$off('clickChat');
    this.$bus.$off('clickZalo');
    if (this._onTaskNoti) this.$bus.$off('taskNotification', this._onTaskNoti);
  }
};
</script>
<style scoped>
:deep(.mention-highlight) {
  color: #327ae7;
  font-weight: 600;
  background-color: rgba(50, 122, 231, 0.12);
  padding: 2px 4px;
  border-radius: 4px;
}
</style>
<style lang="scss" scoped>
.format {
  background-color: #d4e4ffad;
  color: #327ae7;
  border-radius: 16px;
  max-width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.format-select {
  background-color: #d4e4ffad;
  color: #327ae7;
  border-radius: 14px;
  max-width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  margin-bottom: 4px;
}

.font-size-14 {
  font-size: 14px;
}
.font-size-16 {
  font-size: 16px;
}
.header-tab {
  height: 50px;
}
.header-tab span.active {
  color: #2970dd;
  background: #d4e4ff;
  font-weight: 700;
}
.content {
  // border-top: 1px #ececec solid;
  border-bottom: 1px #ececec solid;
  word-break: keep-all;
}
.info .title,
.history .title {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1%;
  color: #202125;
}
.info span,
.history span {
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 1%;
  color: #202125;
}
.info .text,
.history .text {
  color: #696b72;
}

.icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2970dd;
  color: #ffffff;
  cursor: pointer;
}
.icon:hover {
  background: #3081fa;
}
.header-tab {
  background: #f6f6f6;
  padding: 6px 16px;
  border-bottom: 1px #ececec solid;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
}
.header-tab::-webkit-scrollbar {
  height: 6px;
}
.header-tab span {
  padding: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
  color: #696b72;
  border-radius: 4px;
}
.spm-tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 400;
  color: $grey700;
  height: 36px;
  padding: 0 10px;
  width: max-content;
  &.active {
    background-color: $blue100;
    color: $primary;
    font-weight: 600;
  }
  &:hover {
    cursor: pointer;
    background-color: $blue100;
    color: $primary;
  }
}

.item-log {
  background-color: #ececec;
  padding-bottom: 6px;
  margin-bottom: 5px;
  border-radius: 4px;
}

.item-in-item {
  padding: 4px 8px;
  background-color: #ffffff;
  margin: 4px 8px;
}
.file-preview {
  background-color: #d4e4ffad;
  color: #327ae7;
  border-radius: 16px;
  max-width: 170px;
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-count {
  margin-left: 4px;
}
.ellipsis-text-note {
  display: inline-block;
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  margin-top: 0px !important;
  line-height: 16.94px;
}

:deep(.el-table__expanded-cell) {
  background-color: #fafafa;
}
.note {
  max-width: 500px;
  display: inline-block;
  word-wrap: break-word;
  padding-left: 12px
}

.group-btn-conversation {
  position: sticky;
  right: 0;
  background: #f6f6f6;
}

.btn-conversation {
  height: 34px;
  width: 34px;
  background: #d4e4ff !important;
}
.btn-conversation.active {
  background: #0a58c0 !important;
}

.img-logo {
  height: 34px;
  width: 34px;
  object-fit: contain;
}
.note-tab {
  height: calc(80vh - 289px) !important;
}
.tab-log-system,
.tab-log-call {
  height: calc(80vh - 150px) !important;
}
.tab-appointment {
  height: calc(80vh - 310px) !important;
}

// @media (min-width: 1024px) and (max-width: 1920px) {
//   .note-tab {
//     height: 200px !important;
//   }
//   .tab-log-system,
//   .tab-log-call {
//     height: 350px !important;
//   }
// }
// @media (min-width: 1921px) {
//   .note-tab {
//     height: 350px !important;
//   }
//   .tab-log-system,
//   .tab-log-call {
//     height: 490px !important;
//   }
// }

::-webkit-scrollbar {
  height: 0.25rem !important;
}
.collapse {
  transition: all 0.1s ease-out;
}
.custom-box {
  background-color: white;
  border: 1px solid #ced2d680;
  border-radius: 8px;
}
.custom-tab {
  background-color: #ececec;
  border-radius: 16px;
}
.noti-custom {
  background-color: #eaecf2;
  padding: 2px 6px;
  border-radius: 32px;
}
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(100% - 117px);
  display: inline-block;
  vertical-align: middle;
}
</style>
